var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _vm.detail
    ? _c(
        "div",
        { staticClass: "container-zhaopin-detail" },
        [
          _c("div", { staticClass: "job-name" }, [
            _vm._v(_vm._s(_vm.detail.title) + " "),
            _c("div", { staticClass: "salary" }, [
              _vm._v(_vm._s(_vm.detail.xinzi)),
            ]),
          ]),
          _vm._v(" "),
          _c("div", { staticClass: "tag-list" }, [
            _c("span", { staticClass: "tag" }, [
              _vm._v(_vm._s(_vm.detail.gzqy)),
            ]),
            _vm._v(" "),
            _c("span", { staticClass: "tag" }, [
              _vm._v(_vm._s(_vm.detail.gznx)),
            ]),
            _vm._v(" "),
            _c("span", { staticClass: "tag" }, [
              _vm._v(_vm._s(_vm.detail.xueli)),
            ]),
            _vm._v(" "),
            _c("img", {
              staticClass: "share",
              attrs: { src: require("../../images/share.png") },
              on: {
                click: function ($event) {
                  _vm.showShareCover = true
                },
              },
            }),
          ]),
          _vm._v(" "),
          _c(
            "swiper",
            {
              ref: "mySwiper",
              staticClass: "swiper",
              attrs: { options: _vm.swiperOption },
            },
            [
              _vm._l(_vm.detail.pics, function (pic, index) {
                return _c("swiper-slide", { key: index }, [
                  _c("img", { attrs: { src: pic.pic_path } }),
                ])
              }),
              _vm._v(" "),
              _c("div", {
                staticClass: "swiper-pagination",
                attrs: { slot: "pagination" },
                slot: "pagination",
              }),
            ],
            2
          ),
          _vm._v(" "),
          _c("div", [
            _c("div", { staticClass: "title" }, [_vm._v("职位详情")]),
            _vm._v(" "),
            _c("div", {
              staticClass: "job-detail",
              domProps: { innerHTML: _vm._s(_vm.detail.content) },
            }),
          ]),
          _vm._v(" "),
          _c("div", [
            _c("div", { staticClass: "title" }, [_vm._v("工作地点")]),
            _vm._v(" "),
            _c("div", { staticClass: "job-position" }, [
              _vm._v(_vm._s(_vm.detail.gzdd)),
            ]),
            _vm._v(" "),
            _c("div", {
              ref: "map",
              staticClass: "baidu-map",
              on: { click: _vm.handleMap },
            }),
          ]),
          _vm._v(" "),
          _c("div", { staticClass: "btn-group" }, [
            _vm.isManager
              ? _c(
                  "div",
                  { staticClass: "btn", on: { click: _vm.goShareList } },
                  [_vm._v("分享列表")]
                )
              : _vm._e(),
            _vm._v(" "),
            _c("div", { staticClass: "btn", on: { click: _vm.callPhone } }, [
              _vm._v("立即沟通"),
            ]),
          ]),
          _vm._v(" "),
          _vm.showShareCover
            ? _c(
                "div",
                {
                  staticClass: "share-cover",
                  on: {
                    click: function ($event) {
                      _vm.showShareCover = false
                    },
                  },
                },
                [
                  _c("img", {
                    attrs: { src: require("../../images/share-it.png") },
                  }),
                ]
              )
            : _vm._e(),
        ],
        1
      )
    : _vm._e()
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }